import { FunctionType } from '../global-types';

const isFunction = (item: unknown): item is FunctionType => {
  return typeof item === 'function';
};

export { isFunction };
